import * as React from 'react';
import { Form, Text, Select, TextArea } from 'react-form';
import Select2 from 'react-select/lib/Creatable';
import { api } from '@src/services/api';
import { checkLevel, isLevel } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';
import { DepLocalProps, DepLocalState, BatteryDepartments } from './Actions/Battery';
import { Switch } from '@src/services/form';

// typing
interface LocalProps extends DepLocalProps {
    item?: any;
}
interface LocalState extends DepLocalState {
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Battery extends BatteryDepartments<LocalProps, LocalState> {
    state = {} as LocalState;


    localSave( v ) {
        v = { ...v, deptid: this.state.departmentSelectValue };
        this.save(v);
    }

	// render
	render() {
        const loading = this.loading();
        if (loading) return null;
        const { id, item, onCancel } = this.props;
        const { data, values = {}, entity = null, error, departmentSelectLoading, departmentSelectValue } = this.state;
        if (entity === null) return null;

        const disabled = item && (item.mounted || item.shared);

        const customers = data.customers ? data.customers.map( v => ({ value: v.id, label: v.name })) : [];
        const voltages = data.voltages.map( v => ({ value: v.id, label: v.name }));
        const custid = values.custid || (entity ? entity.custid : null);
        const isNew = values.is_new !== undefined ? values.is_new : (entity ? entity.is_new : true);
        const fleets = data.fleets.map(v=> ({ value: v.id, label: v.name }))
        let departments = [] as any;
        if (custid) {
            departments = data.departments.filter( v => v.custid === custid ).map( v => ({ value: v.id, label: v.name }));
        }
        const technologies = data.technologies.map( v => ({ value: v.id, label: v.name }));
        
        return (
            <Modal
                title={!id ? _('new_title', 'SettingsBattery') : _('edit_title', 'SettingsBattery', { name: entity.description } ) }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.localSave(v)}
                        defaultValues={entity}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onChange={() => setTimeout(() => { this.setState({ values: formApi.getFormState().values }); }) }
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="serialno">{_(`field_serialno`, 'SettingsBattery')}</label>
                                    <Text field="serialno" id="serialno" className="form-control" disabled={disabled} />
                                </article>
                                <article>
                                    <label htmlFor="brand">{_(`field_brand`, 'SettingsBattery')}</label>
                                    <Text field="brand" id="brand" className="form-control" disabled={disabled} />
                                </article>
                                <article>
                                    <label htmlFor="model">{_(`field_model`, 'SettingsBattery')}</label>
                                    <Text field="model" id="model" className="form-control" disabled={disabled} />
                                </article>
                                <article>
                                    <label htmlFor="custid">{_(`field_custid`, 'SettingsBattery')}</label>
                                    <Text field="custid" id="custid" value={customers.filter(c => c.id === entity.custid)} className="form-control" disabled={true} />
                                </article>
                                {custid && !checkLevel('hyster') &&
                                <article>
                                    <label htmlFor="deptid">{_('field_deptid', 'SettingsBattery')}</label>
                                    {!isLevel('customer') &&
                                    <Select2
                                        field="deptid"
                                        id="deptid"
                                        options={this.addDefaultOption(departments, _('default_option_none'))}
                                        onCreateOption={(v) => this.addDepartment(formApi, values.custid, v)}
                                        isDisabled={departmentSelectLoading}
                                        isLoading={departmentSelectLoading}
                                        value={departments.filter( (v) => (v.value === departmentSelectValue) )[0]}
                                        defaultValue={entity ? departments.filter( (v) => (v.value === entity.deptid) )[0] : null}
                                        onChange={(value, action) => this.changedDepartment(formApi, value, action)}
                                    />
                                    }
                                    {isLevel('customer') &&
                                    <Select field="deptid" id="deptid" options={this.addDefaultOption(departments, _('default_option_none'))} className="form-control" />
                                    }
                                </article>
                                }
                                {/*sites &&
                                <article>
                                    <label htmlFor="TODO">Site</label>
                                    <Select field="TODO" id="TODO" options={sites} className="form-control" />
                                </article>
                                */}
                                {/*}
                                <article>
                                    <label htmlFor="fleetid">Battery Fleet</label>
                                    <Text field="fleetid" id="fleetid" className="form-control" />
                                </article>
                                */}
                                <article>
                                    <label htmlFor="batterytype">{_(`field_batterytype`, 'SettingsBattery')}</label>
                                    <Select field="batterytype" id="batterytype" options={technologies} className="form-control" disabled={disabled} />
                                </article>
                                <article>
                                        <label htmlFor="nominalvoltage">{_(`field_nominalvoltage`, 'SettingsBattery')}</label>
                                        <Select field="nominalvoltage" id="nominalvoltage" options={voltages} className="form-control" disabled={disabled} />
                                </article>
                                <article>
                                    <label htmlFor="nominalcapacity">{_(`field_nominalcapacity`, 'SettingsBattery')}</label>
                                    <Text field="nominalcapacity" id="nominalcapacity" className="form-control" type="number" disabled={disabled} />
                                </article>
                                <article>
                                    <label htmlFor="description">{_(`field_description`, 'SettingsBattery')}</label>
                                    <TextArea field="description" id="description" className="form-control" disabled={disabled} />
                                </article>
                                <article>
                                        <label htmlFor="fleetname">{_(`field_fleet`, 'SettingsBattery')}</label>
                                        <Select field="fleetname" id="fleetname" options={fleets} className="form-control" disabled={disabled} />
                                </article>
                                {!disabled &&
                                <>
                                <article className="switch">
                                    <label htmlFor="is_new">{_(`field_isnew`, 'SettingsBattery')}</label>
                                    <Switch field="is_new" id="is_new" disabled={disabled} />
                                </article>
                                {!isNew &&
                                <article>
                                    <label htmlFor="starting_cycles">{_(`field_starting_cycles`, 'SettingsBattery')}</label>
                                    <Text type="number" field="starting_cycles" id="starting_cycles" className="form-control" disabled={disabled} />
                                </article>
                                }
                                </>
                                }
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'Settings')}
                                </button>
                                {(!disabled || (item && !checkLevel('hyster') && departments)) &&
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_save`, 'Settings')} 
                                </button>
                                }
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Settings/Battery.tsx